'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormattedCurrency = require('I18n/components/FormattedCurrency');

var _FormattedCurrency2 = _interopRequireDefault(_FormattedCurrency);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITable = require('UIComponents/table/UITable');

var _UITable2 = _interopRequireDefault(_UITable);

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExampleSubtext = function ExampleSubtext(_ref) {
  var currencyCode = _ref.currencyCode,
      priceTiers = _ref.priceTiers,
      handleClickLink = _ref.handleClickLink;

  var exampleFirstValue = priceTiers[1].value;
  var exampleSecondValue = priceTiers[2].value;
  var HREF = (0, _urls.getProductsAndServicesCatalogUrl)();
  return _react2.default.createElement(
    'div',
    { className: 'text-left' },
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'contactConfirmation.contactTierPricingModal.contactsSubtext1_jsx',
          elements: { UILink: _UILink2.default },
          options: {
            onClick: function onClick() {
              for (var _len = arguments.length, partialArgs = Array(_len), _key = 0; _key < _len; _key++) {
                partialArgs[_key] = arguments[_key];
              }

              return handleClickLink.apply(undefined, [HREF, 'marketing-stater-subtext1'].concat(partialArgs));
            },
            link: HREF
          }
        })
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'contactConfirmation.contactTierPricingModal.contactsSubtext2_jsx',
          elements: { FormattedNumber: _FormattedNumber2.default }
        })
      )
    ),
    _react2.default.createElement(
      'p',
      { className: 'p-left-8' },
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'contactConfirmation.contactTierPricingModal.contactsSubtext3_jsx',
          elements: { FormattedCurrency: _FormattedCurrency2.default, FormattedNumber: _FormattedNumber2.default },
          options: {
            firstValue: exampleFirstValue,
            secondValue: exampleSecondValue,
            currencyCode: currencyCode
          }
        })
      )
    ),
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-0' },
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'contactConfirmation.contactTierPricingModal.contactsSubtext4_jsx',
          elements: { UILink: _UILink2.default },
          options: {
            onClick: function onClick() {
              for (var _len2 = arguments.length, partialArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                partialArgs[_key2] = arguments[_key2];
              }

              return handleClickLink.apply(undefined, [HREF, 'marketing-starter-subtext4'].concat(partialArgs));
            },
            link: HREF
          }
        })
      )
    )
  );
};

var PriceTiers = function PriceTiers(_ref2) {
  var currencyCode = _ref2.currencyCode,
      priceTiers = _ref2.priceTiers;

  var handleClickLink = function handleClickLink(source, href) {
    (0, _getUsageTracker2.default)().track('externalLinkClick', {
      name: source,
      url: href
    });
  };

  var contactQuantityMuliplier = 1000;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _UITable2.default,
      null,
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { className: 'text-left' },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contactTierPricingModal.contactsColumnHeader' })
          ),
          _react2.default.createElement(
            'th',
            { className: 'text-right' },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contactTierPricingModal.priceColumnHeader' })
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        priceTiers.map(function (priceTier, index) {
          var upperBound = priceTier.upperBound,
              lowerBound = priceTier.lowerBound,
              value = priceTier.value;

          var lowerBoundToLastUpperBoundDiff = contactQuantityMuliplier - 1;
          var tierText = void 0;
          if (!lowerBound) {
            tierText = _react2.default.createElement(_FormattedMessage2.default, {
              message: 'contactConfirmation.contactTierPricingModal.lowestTier',
              options: { value: upperBound * contactQuantityMuliplier }
            });
          } else if (!upperBound) {
            tierText = _react2.default.createElement(_FormattedMessage2.default, {
              message: 'contactConfirmation.contactTierPricingModal.highestTier',
              options: {
                value: lowerBound * contactQuantityMuliplier - lowerBoundToLastUpperBoundDiff
              }
            });
          } else {
            tierText = _react2.default.createElement(_FormattedMessage2.default, {
              message: 'contactConfirmation.contactTierPricingModal.middleTier',
              options: {
                lowerBound: lowerBound * contactQuantityMuliplier - lowerBoundToLastUpperBoundDiff,
                upperBound: upperBound * contactQuantityMuliplier
              }
            });
          }

          var priceText = void 0;
          if (!lowerBound) {
            priceText = _react2.default.createElement(_FormattedCurrency2.default, { value: value, currencyCode: currencyCode });
          } else {
            priceText = _react2.default.createElement(_FormattedJSXMessage2.default, {
              message: 'contactConfirmation.contactTierPricingModal.pricePerThousand_jsx',
              elements: { FormattedCurrency: _FormattedCurrency2.default, FormattedNumber: _FormattedNumber2.default },
              options: {
                value: value,
                thousand: contactQuantityMuliplier,
                currencyCode: currencyCode
              }
            });
          }

          return _react2.default.createElement(
            'tr',
            { key: index },
            _react2.default.createElement(
              'td',
              { className: 'text-left' },
              tierText
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-right' },
              priceText
            )
          );
        })
      )
    ),
    _react2.default.createElement(ExampleSubtext, {
      priceTiers: priceTiers,
      currencyCode: currencyCode,
      handleClickLink: handleClickLink
    })
  );
};

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var termId = _ref3.termId;
  return {
    priceTiers: (0, _PricingSelectors.contactTierPriceMapSelector)(state, _MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS, termId)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PriceTiers);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/contacts-confirmation-page/PriceTiers.js
// module id = 670
// module chunks = 3 4